export const StripeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="6" fill="#635BFF" />
      <path
        d="M14.347 12.227c0-.706.582-1.007 1.484-.994 1.316.017 2.964.408 4.282 1.115V9.234a11.368 11.368 0 00-4.282-.8c-3.605 0-6.003 1.907-6.003 5.082 0 4.957 6.81 4.16 6.81 6.297 0 .834-.722 1.107-1.727 1.107-1.493 0-3.39-.615-4.893-1.443v3.168a12.43 12.43 0 004.893 1.02c3.726 0 6.282-1.86 6.282-5.072-.013-5.352-6.846-4.393-6.846-6.366z"
        fill="#fff"
      />
    </svg>
  );
};
